import { render, staticRenderFns } from "./product_display.vue?vue&type=template&id=38e8c862&scoped=true"
import script from "./product_display.vue?vue&type=script&lang=js"
export * from "./product_display.vue?vue&type=script&lang=js"
import style0 from "./product_display.vue?vue&type=style&index=0&id=38e8c862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8c862",
  null
  
)

export default component.exports